/* --- CODE CŨ ĐÃ COMMENT THEO YÊU CẦU --- */
/*
const hasPermission = ({ actions = "" }) => {
  // Lấy quyền từ localStorage (đã decode)
  let storedPermissions = [];

  try {
    const data = localStorage.getItem("permissions");
    // console.log(data, "data");

    if (data) {
      const decoded = atob(data); // Giải mã base64
      storedPermissions = JSON.parse(decoded).map((p) => p.toLowerCase());
    }
  } catch (e) {
    console.error("Invalid permissions in localStorage:", e);
  }

  if (!storedPermissions || storedPermissions.length === 0) return false;

  // Nếu actions rỗng => mặc định cho phép
  if (!actions || (Array.isArray(actions) && actions.length === 0)) return true;

  // Trường hợp actions là string
  if (typeof actions === "string") {
    return storedPermissions.includes(actions.toLowerCase());
  }

  // Trường hợp actions là mảng
  const mustHave = actions
    .filter((a) => typeof a === "string")
    .every((a) => storedPermissions.includes(a.toLowerCase()));

  const mustOneOf = actions
    .filter((a) => Array.isArray(a))
    .some((group) =>
      group.every((a) => storedPermissions.includes(a.toLowerCase()))
    );

  return mustHave && (mustOneOf || actions.every((a) => typeof a === "string"));
};

export default hasPermission;
*/

// --- CODE MỚI ---
// Cache lưu trữ mảng quyền đã giải mã trong RAM
let cachedEncoded = null;
let cachedDecodedList = [];

const getDecodedPermissions = () => {
  try {
    const data = localStorage.getItem("permissions");
    if (!data) return [];

    // Nếu dữ liệu mã hóa giống như cũ, dùng luôn kết quả cache trong bộ nhớ RAM (O(1))
    if (data === cachedEncoded) {
      return cachedDecodedList;
    }

    // Nếu thay đổi, tiến hành giải mã Base64 và parse JSON mới
    const decoded = atob(data);
    const parsed = JSON.parse(decoded).map((p) => p.toLowerCase());
    
    // Lưu lại cache
    cachedEncoded = data;
    cachedDecodedList = parsed;
    
    return parsed;
  } catch (e) {
    console.error("Invalid permissions in localStorage:", e);
    return [];
  }
};

const hasPermission = ({ actions = "" }) => {
  const storedPermissions = getDecodedPermissions();

  if (!storedPermissions || storedPermissions.length === 0) return false;

  // Nếu actions rỗng => mặc định cho phép
  if (!actions || (Array.isArray(actions) && actions.length === 0)) return true;

  // Trường hợp actions là string
  if (typeof actions === "string") {
    return storedPermissions.includes(actions.toLowerCase());
  }

  // Trường hợp actions là mảng
  // const mustHave = actions
  //   .filter((a) => typeof a === "string")
  //   .every((a) => storedPermissions.includes(a.toLowerCase()));

  const mustHave = actions
    .filter((a) => typeof a === "string")
    .some((a) => storedPermissions.includes(a.toLowerCase()));

  const mustOneOf = actions
    .filter((a) => Array.isArray(a))
    .some((group) =>
      group.every((a) => storedPermissions.includes(a.toLowerCase()))
    );

  return mustHave && (mustOneOf || actions.every((a) => typeof a === "string"));
};

export default hasPermission;
// ----------------
